module.exports = __webpack_public_path__ + "static/media/11.55feef4d.jpg";